import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import BlogPost from "../Blog/post"

const BlogPostPage = () => {
  const pageContext = usePageContext()
  
  // Extract postID from URL pathname (e.g., /blog/my-post-slug)
  const pathname = pageContext?.urlPathname || ''
  const pathSegments = pathname.split('/').filter(Boolean)
  const postID = pathSegments[1] // Get the segment after /blog/

  if (!postID) {
    return <div>Error: No post ID found in the URL.</div>
  }

  return <BlogPost postID={postID} />
}

// onBeforeRender hook for blog post meta tags
export const onBeforeRender = async (pageContext) => {
  const requestPath = pageContext.urlParsed?.pathname || pageContext.urlPathname || '/'
  
  const blogPostMatch = requestPath.match(/^\/blog\/(.+)$/)
  
  if (!blogPostMatch) {
    return {}
  }

  const slug = blogPostMatch[1]
  
  try {
    const { GetCMSContent } = await import('aldoo-ra/CMS/api')
    const { url } = await import('aldoo-ra/CMS/url')
    
    const response = await GetCMSContent({
      page: 1,
      itemsPerPage: 1,
      match: {
        'content.type': 'BlogPost',
        'content.slug': slug
      },
      expand: true
    })
    
    if (response.data && response.data.length > 0) {
      const post = response.data[0].content

      // Use SEO fields if available, fallback to regular fields
      const seoTitle = post.seo_title || post.title || 'Blog Post'
      const seoDescription = post.seo_description || post.title || 'Read our latest blog post'
      const seoImage = post.seo_image || post.thumbnail || '/static/images/og_image.jpg'

      // Join tags array if it exists
      const tags = Array.isArray(post.tags) ? post.tags.join(', ') : ''

      return {
        title: seoTitle,
        description: seoDescription,
        thumbnail: url(seoImage) || seoImage,
        tags: tags,
        metadata: {
          ogType: 'article'
        }
      }
    }
  } catch (error) {
    console.error('BlogPostPage onBeforeRender ERROR:', error)
  }

  return {}
}

// Attach the onBeforeRender hook directly to the component for auto-discovery
BlogPostPage.onBeforeRender = onBeforeRender

export default BlogPostPage